import { Component, Input, OnInit } from '@angular/core';
import { TransactionService } from 'src/app/pages/transaction/services/transaction.service';

@Component({
  selector: 'prgov-filters',
  templateUrl: './filters.component.html',
  styleUrls: ['./filters.component.scss'],
})
export class FiltersComponent implements OnInit {
  transactionsStatus: any[];
  transactionsTypes: any[];
  showFilters = false;
  @Input() disableOtherFilters = false;
  constructor(private transactionService: TransactionService) {}

  ngOnInit() {
    // this.transactionsStatus = this.transactionService.getTransactionsStatus();
    // this.transactionsTypes = this.transactionService.getTransactionsTypes();
  }

  toggleFilters() {
    this.showFilters = !this.showFilters;
  }
}
